import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetLikedUsersLoading, EGetLikedUsersActionType, TGetLikedUsersParams } from './types';

export const getLikedUsersLoading: (data: TGetLikedUsersParams) => TGetLikedUsersLoading = actionGenerator<
  EGetLikedUsersActionType.Loading,
  TGetLikedUsersParams
>(EGetLikedUsersActionType.Loading);
